/* eslint-disable react/no-did-update-set-state */
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Button from '#components/a/Button'
import HorizontalRule from '#components/a/HorizontalRule'
import Radio from '#components/a/form/Radio'
import Checkbox from '#components/a/form/Checkbox'
import InputNumber from '#components/a/form/InputNumber'
import Tooltip from './Tooltip'

const printModeAll = 'printAll'
const printModeRange = 'printRange'

export default class PrintButtonTooltip extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      max: props.maxNachweisNummer,
      min: props.minNachweisNummer,
      invalid: false,
      printMode: printModeAll,
      printCover: false,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.maxNachweisNummer !== this.props.maxNachweisNummer) {
      this.setState({max: this.props.maxNachweisNummer})
    }

    if (prevProps.minNachweisNummer !== this.props.minNachweisNummer) {
      this.setState({min: this.props.minNachweisNummer})
    }
  }

  handleMaxChange = e => {
    const {maxNachweisNummer} = this.props
    const newValue = parseInt(e.target.value, 10)
    const {min} = this.state
    this.setState({printMode: printModeRange})

    if (isNaN(newValue)) {
      this.setState({
        max: '',
      })
    } else if (newValue > maxNachweisNummer) {
      this.setState({
        max: maxNachweisNummer,
      })
    } else if (newValue < 1) {
      this.setState({
        max: 1,
      })
    } else {
      this.setState({
        max: newValue,
        invalid: newValue < min,
      })
    }
  }

  handleMinChange = e => {
    const {maxNachweisNummer} = this.props
    const {max} = this.state
    const newValue = parseInt(e.target.value, 10)
    this.setState({printMode: printModeRange})

    if (isNaN(newValue)) {
      this.setState({
        min: '',
      })
    } else if (newValue > maxNachweisNummer) {
      this.setState({
        min: maxNachweisNummer,
      })
    } else if (newValue < 1) {
      this.setState({
        min: 1,
      })
    } else {
      this.setState({
        min: newValue,
        invalid: newValue > max,
      })
    }
  }

  handlePrintModeChange = e => {
    this.setState({printMode: e.target.value})
  }

  handlePrintCoverToggle = () => {
    this.setState(prevState => ({
      printCover: !prevState.printCover,
    }))
  }

  handlePrintButton = async () => {
    this.setState({isLoading: true})
    const {printMode, printCover, min, max} = this.state
    let minNumber

    if (printMode === printModeRange) {
      if (min !== '') {
        minNumber = min
      } else {
        minNumber = this.props.minNachweisNummer
      }
    } else minNumber = this.props.minNachweisNummer

    let maxNumber

    if (printMode === printModeRange) {
      if (max !== '') {
        maxNumber = max
      } else {
        maxNumber = this.props.maxNachweisNummer
      }
    } else maxNumber = this.props.maxNachweisNummer

    await this.props.handlePrint(minNumber, maxNumber, printCover)

    this.setState({isLoading: false, min: minNumber, max: maxNumber})
  }

  render() {
    const {minNachweisNummer, maxNachweisNummer} = this.props

    const {max, min, printMode, printCover, isLoading, invalid} = this.state

    return (
      <Tooltip
        modifier="print"
        placement="bottom-start"
        trigger={
          <Button
            text={i18n.t('export_print_buttontext')}
            variant="secondary"
            modifiers={['print']}
            testid="print-button"
          />
        }>
        <Radio
          labelText={i18n.t('ausbildungsnachweis_print_all')}
          value={printModeAll}
          checked={printMode === printModeAll}
          onChangeHandle={this.handlePrintModeChange}>
          {printMode === printModeAll && (
            <Checkbox
              onChangeHandle={this.handlePrintCoverToggle}
              checked={printCover}
              labelText={i18n.t('ausbildungsnachweis_print_withDeckblatt')}
            />
          )}
        </Radio>
        <HorizontalRule />
        <Radio
          labelText={i18n.t('misc_nachweis_nummer')}
          value={printModeRange}
          checked={printMode === printModeRange}
          onChangeHandle={this.handlePrintModeChange}>
          <div>
            <div className="radio__children">
              <InputNumber
                labelText={i18n.t('ausbildungsnachweis_print_range_from')}
                minValue={minNachweisNummer}
                maxValue={maxNachweisNummer}
                value={min}
                onChangeHandle={this.handleMinChange}
                modifier="inline dark"
              />
              <InputNumber
                labelText={i18n.t('ausbildungsnachweis_print_range_to')}
                minValue={minNachweisNummer}
                maxValue={maxNachweisNummer}
                value={max}
                onChangeHandle={this.handleMaxChange}
                modifier="inline dark"
              />
            </div>
            {printMode === printModeRange && (
              <Checkbox
                onChangeHandle={this.handlePrintCoverToggle}
                checked={printCover}
                labelText={i18n.t('ausbildungsnachweis_print_withDeckblatt')}
              />
            )}
          </div>
        </Radio>
        <HorizontalRule />
        <Button
          event={this.handlePrintButton}
          text={i18n.t('export_print_buttontext')}
          variant="primarydark"
          disabled={isLoading || invalid}
        />
      </Tooltip>
    )
  }
}

PrintButtonTooltip.propTypes = {
  handlePrint: PropTypes.func.isRequired,
  minNachweisNummer: PropTypes.number.isRequired,
  maxNachweisNummer: PropTypes.number.isRequired,
}
